import { render, staticRenderFns } from "./UpgradeNeededPageOverlay.vue?vue&type=template&id=a41571ec"
import script from "./UpgradeNeededPageOverlay.vue?vue&type=script&lang=js"
export * from "./UpgradeNeededPageOverlay.vue?vue&type=script&lang=js"
import style0 from "./UpgradeNeededPageOverlay.vue?vue&type=style&index=0&id=a41571ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports